export default __webpack_public_path__ + "static/media/logo.d3a224e8.png";